<template>
  <v-card :loading="loading" outlined>
    <ListTitle
      v-if="hideTitle"
      :access="false"
      title="Payment Methods"
      :showBackButton="false"
    />
    <v-card-text class="mb-0 pb-0">
      <v-row>
        <v-spacer> </v-spacer>
        <v-col cols="12" md="3" sm="12" >
          <DateTimePicker
            defaultRange="today"
            :range="true"
            v-model="dateTime"
            @submit="loadData()"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <div id="stock-line"></div>
  </v-card>
</template>

<script>
import paymentService from "@/modules/Customer/Payment/service";
// import $ from "jquery";
const DateTimePicker = () => import("@/components/DateTimePicker");
import Highcharts from "highcharts";

export default {
  props: {
    hideTitle: {
      default: true,
    },
    start: {
      default: null,
    },
    end: {
      default: null,
    },
  },
  data() {
    return {
      dateTime: {
        start: this.$moment().startOf("day").toISOString(),
        end: this.$moment().endOf("day").toISOString(),
      },
      loading: false,
    };
  },
  mounted() {
    this.loadData();
  },
  components: {
    DateTimePicker,
  },
  methods: {
    loadData() {
      this.loading = true;
      let where = {};
      where = {
        start: this.dateTime.start,
        end: this.dateTime.end,
      };

      console.log("were", where);
      return paymentService.groupByPaymentMethod(where).then((response) => {
        console.log("response", response);
        if (response.data) {
          var newData = [];
          response.data.forEach((row) => {
            newData.push([row.paymentMethod, row.totalPayment | 0]);
          });
          newData.sort(function (a, b) {
            return b[1] - a[1];
          });
          this.loading = false;
          // console.log('newData', newData)
          Highcharts.chart("stock-line", {
            credits: false, // Disable HighCharts logo// Set Colors
            chart: {
              type: "column",
            },
            title: false,
            xAxis: {
              type: "category",
              labels: {
                rotation: -45,
                style: {
                  fontSize: "13px",
                  fontFamily: "Verdana, sans-serif",
                },
              },
            },
            yAxis: {
              title: {
                text: "Sales",
              },
              labels: {
                formatter: function () {
                  return this.value / 1000000 + "m";
                },
              },
            },
            legend: {
              enabled: false,
            },
            tooltip: {
              pointFormat: "{series.name} is collected: <b>{point.y:.2f} </b>",
            },
            series: [
              {
                name: "Payment",
                data: newData,
                color: "#FBC02D",
                dataLabels: {
                  enabled: true,
                  format: "{point.y:.2f}", // one decimal
                  style: {
                    fontSize: "13px",
                    fontFamily: "Verdana, sans-serif",
                  },
                },
              },
            ],
          });
        }
      });
    },
  },
};
</script>
